/* CoziKat hero slideshow — crossfade + dot navigation.

   Mirrors the mockup's hero script, but scoped per section instance so more
   than one hero can live on a page, and re-initialised on shopify:section:load
   so it keeps working while the theme editor re-renders the section. */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(root) {
    if (!root || root.dataset.ckHeroReady === 'true') return;
    root.dataset.ckHeroReady = 'true';

    var slides = root.querySelectorAll('[data-ck-slide]');
    var copies = root.querySelectorAll('[data-ck-copy]');
    var dots = root.querySelectorAll('[data-ck-dot]');
    var count = slides.length;
    if (count === 0) return;

    var current = 0;
    var timer = null;
    var speed = (parseFloat(root.dataset.speed) || 5) * 1000;
    // Auto-rotation is suppressed for visitors who asked for reduced motion.
    var autoplay = root.dataset.autoplay === 'true' && !reduceMotion && count > 1;

    function mark(list, index) {
      for (var i = 0; i < list.length; i++) {
        list[i].classList.toggle('is-active', i === index);
      }
    }

    function go(index) {
      current = ((index % count) + count) % count;
      mark(slides, current);
      mark(copies, current);
      mark(dots, current);
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', i === current ? 'true' : 'false');
      }
    }

    function start() {
      if (!autoplay || timer) return;
      timer = setInterval(function () {
        go(current + 1);
      }, speed);
    }

    function stop() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }

    for (var i = 0; i < dots.length; i++) {
      (function (index) {
        dots[index].addEventListener('click', function () {
          stop();
          go(index);
          start();
        });
      })(i);
    }

    // Don't burn a timer while the tab is in the background.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    go(0);
    start();
  }

  function initAll(scope) {
    var heroes = (scope || document).querySelectorAll('[data-cozikat-hero]');
    for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: the section is replaced wholesale, so the new copy needs
  // wiring up (the fresh DOM has no ckHeroReady flag, so this is idempotent).
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
